import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, ChevronRight, HelpCircle, LifeBuoy, Mail, MessageCircle } from "lucide-react";
import "../account.css";
import "./accountHelpAndSupport.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";

const AccountHelpAndSupport = () => {
	const { language, userData } = useContext(CombinedContext);
	const navigate = useNavigate();
	const role = userData?.user?.role;
	const isOwner = role === "owner" || role === "admin";

	const t = translations[language].account.helpAndSupport || {};
	const menu = translations[language].account.menu || {};

	const items = [
		{
			id: "contact",
			label: menu.contact || (language === "es" ? "Contacto" : "Contact"),
			hint: t.contactHint,
			icon: Mail,
			path: "/account/contact",
		},
		{
			id: "faq",
			label: "FAQ",
			hint: t.faqHint,
			icon: HelpCircle,
			path: "/account/faq",
		},
		...(isOwner
			? [
					{
						id: "resources",
						label: language === "es" ? "Recursos para negocios" : "Business Resources",
						hint: t.resourcesHint,
						icon: BookOpen,
						comingSoon: true,
					},
				]
			: []),
	];

	return (
		<div className="ac-page aph">
			<header className="ac-head">
				{/* <span className="ac-eyebrow">{menu.helpandsupport || "Help"}</span> */}
				<h1 className="ac-title">{t.title || menu.helpandsupport}</h1>
				{t.subtitle && <p className="ac-sub">{t.subtitle}</p>}
			</header>

			<section className="ac-card">
				<div className="ac-list">
					{items.map((item) => {
						const Icon = item.icon;
						return (
							<button
								key={item.id}
								type="button"
								className={`ac-row ${item.comingSoon ? "is-muted" : ""}`}
								onClick={() => {
									if (item.comingSoon) return;
									navigate(item.path);
								}}
							>
								<span className="ac-icon">
									<Icon size={16} />
								</span>

								<span className="ac-row-copy">
									<span className="ac-row-label">{item.label}</span>
									{item.hint && <span className="ac-row-hint">{item.hint}</span>}
								</span>

								{item.comingSoon ? (
									<span className="ac-row-tag">
										{translations[language].account.comingSoon || (language === "es" ? "Próximamente" : "Coming soon")}
									</span>
								) : (
									<ChevronRight size={17} className="ac-row-chevron" />
								)}
							</button>
						);
					})}
				</div>
			</section>

			{/* ── STILL STUCK? ── */}
			{t.ctaTitle && (
				<section className="aph-cta">
					<span className="aph-cta-icon">
						<LifeBuoy size={22} />
					</span>

					<div className="aph-cta-copy">
						<h3>{t.ctaTitle}</h3>
						<p>{t.ctaText}</p>
					</div>

					<button className="ac-btn ac-btn--gold" onClick={() => navigate("/account/contact")}>
						<MessageCircle size={15} />
						{t.ctaButton}
					</button>
				</section>
			)}
		</div>
	);
};

export default AccountHelpAndSupport;
